import { render, staticRenderFns } from "./UserSettingsContext.vue?vue&type=template&id=8499d4d2&"
import script from "./UserSettingsContext.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports